import React from 'react';
import Banner from '../components/Banner';
import Banner2 from '../components/Banner2';
import BannerText from '../components/BannerText';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Gallery from '../components/Gallery';
import Header from '../components/Header';
import Intro from '../components/Intro';
import Main from '../components/Main';
import Menu from '../components/Menu';
import Reservation from '../components/Reservation';
import Team from '../components/Team';
const HomeView = () => {
  return (
    <>
      <Header />
      <Main>
        <Intro />
        <BannerText />
        <Team />
        <Banner />
        <Menu />
        <Banner2 />
        <Reservation />
        <Gallery />
        <Contact />
      </Main>
      <Footer />
    </>
  );
};

export default HomeView;
